import { Avatar, Stack, Typography } from '@mui/material'
import CompanyLogo from '../company-logo/company-logo.component'
import MenuIcon from '@mui/icons-material/Menu'
import { Container } from './topbar.styles'
import { useEffect, useMemo, useState } from 'react'
import MobileNav from '../mobile-nav/mobile-nav.component'
import AvatarImg from '../../assets/images/avatar.png'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { getUserId } from 'utils/common'
import { useGetLogoPresignedUrlMutation } from 'store/task-automation/task-automation.api'

const Topbar = () => {
  const [openNavDrawer, setOpenNavDrawer] = useState(false)
  const [logoUrl, setLogoUrl] = useState('')
  const user = useSelector((state: RootState) => state.auth.user)
  const userId = getUserId()
  const [getLogoPresignedUrl] = useGetLogoPresignedUrlMutation()

  const displayName = useMemo(() => {
    if (!user?.id || !user?.companyName) return 'Transpots'
    return user.companyName
  }, [user?.companyName, user?.id])

  useEffect(() => {
    const fetchUserLogo = async () => {
      if (!userId) {
        setLogoUrl('')
        return
      }

      try {
        const response = await getLogoPresignedUrl({ user_id: userId }).unwrap()
        setLogoUrl(response?.presignedUrl || '')
      } catch (_error) {
        setLogoUrl('')
      }
    }

    fetchUserLogo()
  }, [getLogoPresignedUrl, userId])

  const closeDrawer = () => {
    setOpenNavDrawer(false)
  }

  return (
    <Container elevation={4}>
      <MenuIcon
        sx={{ display: { xs: 'block', lg: 'none' } }}
        onClick={() => setOpenNavDrawer(true)}
      />
      <MobileNav open={openNavDrawer} close={closeDrawer} />
      <div></div>
      <Stack direction="row" alignItems="center" spacing={2}>
        <Typography variant="h6" fontSize={20} fontWeight={700}>
          {displayName}
        </Typography>
        {logoUrl ? (
          <CompanyLogo src={logoUrl} maxHeight={34} maxWidth={120} />
        ) : (
          <Avatar src={AvatarImg} sx={{ width: 34, height: 34 }} />
        )}
      </Stack>
    </Container>
  )
}

export default Topbar
